import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building, Search, Bell, Settings, Menu, X } from 'lucide-react';
import apiClient from '../../../services/api';
import './Navbar.css';

const Navbar = () => {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    const fetchNotifications = async () => {
        try {
            const res = await apiClient.get('/bookings');
            if (res.data && res.data.data) {
                // Treat 'Pending' bookings as unread notifications
                const pending = res.data.data.filter(b => b.status === 'Pending');
                const sortedPending = pending.sort((a,b) => b.id - a.id);
                setNotifications(sortedPending);
                setUnreadCount(sortedPending.length);
            }
        } catch (err) {
            console.error("Failed to fetch notifications:", err);
        }
    };

    useEffect(() => {
        // Initial fetch
        fetchNotifications();
        
        const token = localStorage.getItem('token');
        if (!token) return;

        // Establish real-time Server-Sent Events (SSE) connection instead of polling
        const baseURL = apiClient.defaults.baseURL || 'http://localhost:9050/api/v1';
        const sseUrl = `${baseURL}/users/notifications/stream?token=${token}`;
        
        const eventSource = new EventSource(sseUrl);
        
        eventSource.addEventListener('new_booking', (event) => {
            console.log("New real-time booking push received!", event.data);
            try {
                const data = JSON.parse(event.data);
                alert(`🔔 New Booking Received!\nID: ${data.id || 'N/A'}\nGuest: ${data.guest_name || 'N/A'}`);
            } catch (e) {
                alert("🔔 You have a new booking!");
            }
            fetchNotifications();
        });

        return () => {
            eventSource.close();
        };
    }, []);

    const handleBellClick = () => {
        setShowDropdown(!showDropdown);
    };

    const handleNotificationClick = () => {
        setShowDropdown(false);
        navigate('/orders'); // Route logic might be slightly different depending on routing setup
    }

    return (
        <header className="top-navbar">
            <button className="portal-hamburger" onClick={() => window.dispatchEvent(new CustomEvent('togglePortalSidebar'))}>
                <Menu size={22} />
            </button>
            <div className="navbar-logo">
                <img src="/logo-header.png" alt="Somstay" className="logo-img" />
                <span className="logo-text">somstay</span>
            </div>
            
            <div className="navbar-search">
                <Search size={18} className="search-icon" />
                <input type="text" placeholder="Search guests, rooms, or bookings..." />
            </div>

            <div className="navbar-actions">
                <div className="notification-wrapper">
                    <div className="icon-badge-container" onClick={handleBellClick}>
                        <Bell size={20} className="icon" />
                        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                    </div>

                    {showDropdown && (
                        <div className="notification-dropdown">
                            <div className="dropdown-header">
                                <h3>Notifications</h3>
                                {unreadCount > 0 && <span className="badge-pill">{unreadCount} New</span>}
                            </div>
                            <div className="dropdown-body">
                                {notifications.length > 0 ? (
                                    notifications.slice(0, 5).map(n => (
                                        <div key={n.id} className="notification-item" onClick={handleNotificationClick}>
                                            <div className="notif-icon">🔥</div>
                                            <div className="notif-content">
                                                <p><strong>New Order #{n.id}</strong></p>
                                                <p className="notif-desc">
                                                    {n.entity_type} booking starting {new Date(n.check_in).toLocaleDateString()}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-notifications">No new orders.</div>
                                )}
                            </div>
                            <div className="dropdown-footer" onClick={() => { setShowDropdown(false); navigate('/orders'); }}>
                                View All Orders
                            </div>
                        </div>
                    )}
                </div>
                <Settings size={20} className="icon settings-icon" onClick={() => navigate('/settings')} />
            </div>
        </header>
    );
};

export default Navbar;
